import { Route, Switch } from 'react-router-dom';

import { ClientCsvImport, InvoiceCsvImport, InvoicePdfImport, InvoiceUblImport } from './pages';

export const Import = () => (
  <Switch>
    <Route path="/import/clients/csv" component={ClientCsvImport} />
    <Route path="/import/invoices/csv" component={InvoiceCsvImport} />
    <Route path="/import/invoices/pdf" component={InvoicePdfImport} />
    <Route path="/import/invoices/ubl" component={InvoiceUblImport} />
  </Switch>
);
